// fetchData.js
import { collection, getDocs, doc } from "firebase/firestore";
import { db } from "../components/Auth/firebase";

export const fetchAllCollectionsData = async () => {
  const collectionsData = {};
  try {
    // List all the collection names you want to fetch
    const collectionNames = [
      "categories",
      "channels",
      "comments",
      "projects",
      "events",
      "users",
    ];

    for (const collectionName of collectionNames) {
      const colRef = collection(db, collectionName);
      const colSnapshot = await getDocs(colRef);
      const colData = await Promise.all(
        colSnapshot.docs.map(async (doc) => {
          const docData = { id: doc.id, ...doc.data() };

          // If the collection is 'users', fetch subcollection 'boards'
          if (collectionName === "users") {
            const boardsRef = collection(db, `users/${doc.id}/boards`);
            const boardsSnapshot = await getDocs(boardsRef);
            const boardsData = await Promise.all(
              boardsSnapshot.docs.map(async (boardDoc) => {
                const boardData = { id: boardDoc.id, ...boardDoc.data() };

                // Fetch tasks for each board
                const tasksRef = collection(
                  db,
                  `users/${doc.id}/boards/${boardDoc.id}/tasks`
                );
                const tasksSnapshot = await getDocs(tasksRef);
                const tasksData = tasksSnapshot.docs.map((taskDoc) => ({
                  id: taskDoc.id,
                  ...taskDoc.data(),
                }));
                boardData.tasks = tasksData;

                return boardData;
              })
            );
            docData.boards = boardsData;
          }

          return docData;
        })
      );
      collectionsData[collectionName] = colData;
    }
  } catch (error) {
    console.error("Error fetching collections: ", error);
  }

  // Export data as JSON
  const jsonData = JSON.stringify(collectionsData, null, 2);
  return jsonData;
};
